
/* Mail Chip */
export const CREATE_EMAIL = 'app/mailChip/CREATE_EMAIL';
export const END_EMAIL = 'app/email/END_EMAIL';

/* Notifications */
export const SNACKBAR = 'app/notifications/SNACKBAR';
export const DISMISS_SNACKBAR = 'app/notifications/DISMISS_SNACKBAR';

/* User Form */
export const CLEAR_USER_FORM = 'app/userForm/CLEAR_USER_FORM';



/** WEBPACK FOOTER **
 ** ./src/constants/actions.js
 **/